<template>
	<b-form autocomplete="off">
		<b-toast id="my-toast" name="b-toaster-top-center" solid variant="danger">
			<template #toast-title>
				<div class="d-flex flex-grow-1 align-items-baseline">
					<b-img blank blank-color="#ff5555" class="mr-2" height="12" width="12" />
					<b class="mr-auto">Erro!</b>
				</div>
			</template>

			{{ toastMessage }}
		</b-toast>

		<b-form-row>
			<b-col cols="12">
				<input-component
					v-model="fullName"
					:class="{ 'mb-5': $root.isMobile() && hiddenData }"
					:required="true"
					label="Seu Nome Completo"
					maxlength="255"
					name="fullName" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="6">
				<input-component
					v-model="cpf"
					:check="true"
					:class="{ 'mb-5': $root.isMobile() && hiddenData }"
					:mask="'###.###.###-##'"
					:required="true"
					label="CPF"
					maxlength="20"
					name="cpf"
					type="tel" />
			</b-col>

			<b-col cols="12" md="6">
				<input-component
					v-model="phone"
					:check="true"
					:class="{ 'mb-5': $root.isMobile() && hiddenData }"
					:mask="phone.length > 14 ? '(##) #####-####' : '(##) ####-####'"
					:required="true"
					label="Telefone com DDD"
					maxlength="20"
					name="phone"
					type="tel" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="6">
				<input-component
					v-model="email"
					:check="true"
					:class="{ 'mb-5': $root.isMobile() && hiddenData }"
					:required="true"
					label="E-mail de contato"
					maxlength="255"
					name="email"
					type="email" />
			</b-col>

			<b-col cols="12" md="6">
				<input-component
					v-model="taxId"
					:check="true"
					:mask="'##.###.###/####-##'"
					:required="true"
					label="CNPJ da empresa"
					maxlength="50"
					name="taxId" />
			</b-col>
		</b-form-row>

		<div v-if="formSession" class="warning-infos">
			<span class="warning-title">
				Olá! Para facilitar o preenchimento do formulário, tenha à mão os seguintes documentos:
			</span>

			<ul>
				<li v-for="(text, index) in warningTexts" :key="index">{{ text }}</li>
			</ul>

			<div class="final-info">
				<span>Você terá a opção de editar e salvar suas informações para conclusão posterior.</span>
				<span>Estamos aqui para ajudar caso você precise de alguma orientação. Obrigado!</span>
			</div>
		</div>

		<b-form-checkbox
			v-if="!hiddenData"
			id="checkbox-confirm"
			v-model="confirmCheckbox"
			class="mb-3"
			name="checkbox-confirm">
			Autorizo a coleta e utilização dos dados, de acordo com a
			<a href="https://www.pagbrasil.com/pt-br/politica-de-privacidade/" target="_blank">
				Política de Privacidade
			</a>
			.
		</b-form-checkbox>

		<div v-if="!hiddenData" class="d-flex justify-content-center">
			<b-button class="mt-4 button-access bg-primary text-white" @click="handleSubmit">ACESSAR</b-button>
		</div>
	</b-form>
</template>

<script>
import { email, minLength, required } from "vuelidate/lib/validators";
import InputComponent from "@/components/Form/Inputs/InputComponent";

export default {
	components: { InputComponent },
	name: "PersonalFormComponent",
	props: ["hiddenData", "formSession", "validationTrigger"],
	async mounted() {
		if (this.hiddenData) {
			this.$v.$touch();
			this.$emit("setReadyToSubmit", this.isValid);
		}

		this.$store.dispatch("updateStep", this.step);

		if (this.$store.state.form.acceptedPolicy) {
			this.confirmCheckbox = true;
		}

		if (this.$route.query.id != null) {
			sessionStorage.setItem("kyc_uuid", this.$route.query.id);
		}
	},
	data() {
		return {
			warningTexts: [
				"Cartão CNPJ da empresa.",
				"Contrato ou estatuto social.",
				"Última alteração do contrato social, estatuto ou ata (se houver).",
				"Livro de ações (se houver).",
				"Comprovante de endereço da empresa com menos de 3 meses de validade.",
				"Se o(s) sócio(s) for(em) pessoa(s) física(s), cópia de RG, CPF, RNE ou passaporte de todos os sócios pessoa física que contenham igual ou mais do que 25% de participação na sociedade.",
				"Se o(s) sócio(s) for(em) pessoa(s) jurídica(s), contrato social da empresa sócia e cópia de RG, CPF, RNE ou passaporte de cada sócio que contenha igual ou mais de 25% de participação da sócia pessoa jurídica.",
				"Comprovante de endereço dos sócios com menos de 3 meses de validade.",
				"Cópia de RG, CPF, RNE ou passaporte do(s) representante(s) legal(is).",
				"Comprovante de endereço do(s) representante(s) legal(is) com menos de 3 meses de validade.",
			],
			confirmCheckbox: false,
			toastMessage: "Por favor, preencha todos os campos obrigatórios.",
		};
	},
	validations: {
		fullName: {
			required,
			isAlpha(fullName) {
				return this.$root.isAlpha(fullName);
			},
			minLength: minLength(3),
		},
		cpf: {
			required,
			isValidCPF(cpf) {
				return this.$root.isValidCPF(cpf);
			},
		},
		phone: {
			required,
			minLength: minLength(14),
		},
		email: {
			required,
			email,
		},
		taxId: {
			required,
			isValidCNPJ(taxId) {
				return this.$root.isValidCNPJ(taxId);
			},
		},
	},
	methods: {
		makeToast(variant = null, type) {
			let message = "Por favor, preencha os campos obrigatórios.";

			if (type === "cpfCnpj") {
				message = "Não é possível enviar CPF ou CNPJ sem máscara.";
			}

			if (type === "checkbox") {
				message = "Por favor, marque a caixa para concordar com os termos e condições antes de continuar.";
			}

			this.$bvToast.toast(message, {
				title: `Erro`,
				variant,
				solid: true,
				toaster: "b-toaster-top-center",
			});
		},

		async handleSubmit() {
			this.$v.$touch();

			if (this.$v.$invalid || !this.confirmCheckbox) {
				this.$bvToast.show("my-toast");

				return;
			}

			if (!this.taxId.includes("-") || !this.taxId.includes(".") || !this.taxId.includes("/")) {
				this.toastMessage = "Não é possível enviar CPF ou CNPJ sem máscara.";
				this.$bvToast.show("my-toast");

				return;
			}

			this.$emit("loading", true);
			const success = await this.$store.dispatch("submitForm", 0);

			if (!success) {
				return;
			}

			await this.$router.push("/access/code");
		},
	},
	watch: {
		isValid(value) {
			this.$emit("setReadyToSubmit", value);
		},
		validationTrigger() {
			this.$emit("setReadyToSubmit", this.isValid);
		},
	},
	computed: {
		isValid() {
			return !this.$v.$invalid;
		},
		fullName: {
			get() {
				return this.$store.state.form.personal.fullName;
			},
			set(value) {
				this.$store.commit("setPersonal", {
					key: "fullName",
					value,
				});
			},
		},
		cpf: {
			get() {
				return this.$store.state.form.personal.cpf;
			},
			set(value) {
				this.$store.commit("setPersonal", {
					key: "cpf",
					value,
				});
			},
		},
		phone: {
			get() {
				return this.$store.state.form.personal.phone;
			},
			set(value) {
				this.$store.commit("setPersonal", {
					key: "phone",
					value,
				});
			},
		},
		email: {
			get() {
				return this.$store.state.form.personal.email;
			},
			set(value) {
				this.$store.commit("setPersonal", {
					key: "email",
					value,
				});
			},
		},
		taxId: {
			get() {
				return this.$store.state.form.personal.taxId;
			},
			set(value) {
				this.$store.commit("setPersonal", {
					key: "taxId",
					value,
				});
			},
		},
		step() {
			return this.$store.state.form.step;
		},
	},
};
</script>

<style lang="scss" scoped>
.button-access {
	padding: 16px 50px;
}

.warning-infos {
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	font-family: "Nunito sans", sans-serif;

	.warning-title {
		font-weight: 600;
		margin-bottom: 15px;
		font-size: 14px;
	}

	ul {
		margin-left: -25px;

		li {
			margin-top: 10px;
			font-size: 14px;
		}
	}

	.final-info {
		margin-top: 15px;
		display: flex;
		flex-direction: column;
		gap: 5px;
		font-weight: 600;
		margin-bottom: 40px;

		span {
			font-size: 14px;
		}
	}
}

@media only screen and (max-width: 1024px) {
	.button-access {
		padding: 16px 20px;
	}
}
</style>
